
import role from '../helpers/role';
import CompetitionApproval from '../competitionapproval/CompetitionApproval.vue';
import NewCompetitionApproval from '../competitionapproval/NewCompetitionApproval.vue';
import CategoryArt from '../competitionapproval/CategoryArt.vue';
import compAppEventClasses from '../competitionapproval/CompetitionApprovalEventClasses.vue';
import compAppEventClassesMatrix from '../competitionapproval/CompetitionApprovalEventClassesMatrix.vue';
import compApprovalAttachments from '../competitionapproval/CompetitionApprovalAttachments.vue';
import compApprovalRequest from '../competitionapproval/CompetitionApprovalRequest.vue';
import compApprovalDetailView from '../competitionapproval/CompetitionApprovalDetailView.vue';
import compApprovalFinisher from '../competitionapproval/CompetitionApprovalFinisher.vue';
import CompetitionApprovalEditState from '../competitionapproval/CompetitionApprovalEditState.vue';


const router = [{
	path: '/competitionapproval',
	name: 'competitionapproval',
	component: CompetitionApproval,
	meta: {
		authorize: [{ name: role.Any }],
	},
}, {
	path: '/newcompetitionapproval',
	name: 'newcompetitionapproval',
	component: NewCompetitionApproval,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/showcompetitionapproval/:cGuid',
	name: 'showcompetitionapproval',
	component: NewCompetitionApproval,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/editcompetitionapproval/:cGuid',
	name: 'editcompetitionapproval',
	component: NewCompetitionApproval,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/competitionapprovalCategoryArt/:cGuid',
	name: 'categoryArt',
	component: CategoryArt,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/showcompetitionapprovalCategoryArt/:cGuid',
	name: 'showcategoryArt',
	component: CategoryArt,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/competitionapprovalEventClasses/:cGuid',
	name: 'compAppEventClasses',
	component: compAppEventClasses,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/showcompetitionapprovalEventClasses/:cGuid',
	name: 'showcompAppEventClasses',
	component: compAppEventClasses,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/competitionapprovalEventClassesMatrix/:cGuid',
	name: 'compAppEvClMatrix',
	component: compAppEventClassesMatrix,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/showcompetitionapprovalEventClassesMatrix/:cGuid',
	name: 'showcompAppEvClMatrix',
	component: compAppEventClassesMatrix,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/competitionFinisherAttachements/:cGuid',
	name: 'compFinisherAttachments',
	component: compApprovalAttachments,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/competitionapprovalAttachements/:cGuid',
	name: 'compApprovalAttachments',
	component: compApprovalAttachments,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/competitionapprovalAttachementsOnly/:cGuid',
	name: 'compApprovalAttachmentsOnly',
	component: compApprovalAttachments,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/showcompetitionapprovalAttachements/:cGuid',
	name: 'showcompApprovalAttachments',
	component: compApprovalAttachments,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/competitionapprovalEventRequest/:cGuid',
	name: 'compApprovalRequest',
	component: compApprovalRequest,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/competitionapprovalDetailView/:cGuid',
	name: 'compApprovalDetailView',
	component: compApprovalDetailView,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/competitionFinisherDetailView/:cGuid',
	name: 'compFinisherDetailView',
	component: compApprovalDetailView,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/competitionApprovalFinisher/:cGuid',
	name: 'compApprovalFinisher',
	component: compApprovalFinisher,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/CompetitionApprovalEditState/:cGuid',
	name: 'CompetitionApprovalEditState',
	component: CompetitionApprovalEditState,
	meta: {
		authorize: [{ name: role.Approver }],
		parentName: 'competitionapproval',
	},
}, {
	path: '/CompetitionApprovalCancel/:cGuid',
	name: 'CompetitionApprovalCancel',
	component: CompetitionApprovalEditState,
	meta: {
		authorize: [{ name: role.Any }],
		parentName: 'competitionapproval',
	},
}];

export default router;
